import { atom } from "recoil";

type RefreshValue = {
  time: number;
  name: string;
};

const STORAGE_KEY = "time";
const LEGACY_TIME_MAP: Record<number, number> = {
  60000: 30000,
  300000: 30000,
};

export const valuesRefresh: RefreshValue[] = [
  { time: 5000, name: "Every 5 seconds" },
  { time: 15000, name: "Every 15 seconds" },
  { time: 30000, name: "Every 30 seconds" },
];

const defaultRefresh = valuesRefresh[1];

const findRefreshByTime = (value: number): RefreshValue | null => {
  const normalizedTime = LEGACY_TIME_MAP[value] ?? value;
  return valuesRefresh.find((item) => item.time === normalizedTime) ?? null;
};

const getNormalizedRefreshValue = (): RefreshValue => {
  if (typeof window === "undefined" || !window.localStorage) {
    return defaultRefresh;
  }

  const storedValue = localStorage.getItem(STORAGE_KEY);
  if (!storedValue) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultRefresh));
    return defaultRefresh;
  }

  let parsedValue: unknown;
  try {
    parsedValue = JSON.parse(storedValue);
  } catch {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultRefresh));
    return defaultRefresh;
  }

  const parsedTime =
    parsedValue &&
    typeof parsedValue === "object" &&
    "time" in parsedValue &&
    typeof (parsedValue as { time?: unknown }).time === "number"
      ? (parsedValue as { time: number }).time
      : null;

  const normalizedValue =
    parsedTime !== null ? findRefreshByTime(parsedTime) ?? defaultRefresh : defaultRefresh;

  localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizedValue));
  return normalizedValue;
};

export const time = atom<RefreshValue>({
  key: "time",
  default: getNormalizedRefreshValue(),
});
